export default "__VITE_ASSET__Cp_9rzO8__"